import { Loading } from './styled';

export default function MiniLoader(): JSX.Element {
  return <Loading />;
}
